import * as yup from "yup";
import {
  createAccessTypeValidation,
  createExpirationDateValidation,
} from "~/pages/UserAndRoles/utils/workspaceAssignmentValidation";

export const validationSchema = () =>
  yup.object().shape({
    roleGroupName: yup.string().required("Role is required"),
    accessType: createAccessTypeValidation(),
    endDate: createExpirationDateValidation(),
  });
